module.exports = __webpack_public_path__ + "static/media/solution-tube-k.0897709d.svg";